import React, { useMemo } from 'react';
import { Typography, Tag } from 'antd';
import dayjs from 'dayjs';
import CrudPage from '../../../components/common/CrudPage';
import { mentalHealthConfigService } from '../../../services/next';

const { Text } = Typography;

const STATUS_OPTIONS = [
  { label: 'Kích hoạt', value: 1 },
  { label: 'Tạm dừng', value: 0 },
];

const QuanLyCauHinhSucKhoeTinhThan = () => {
  const columns = useMemo(() => [
    { title: 'ID', dataIndex: 'id', key: 'id', width: 80 },
    { title: 'KEY CẤU HÌNH', dataIndex: 'key', key: 'key', width: 250, render: (t) => <Text strong code>{t}</Text> },
    { title: 'GIÁ TRỊ (VALUE)', dataIndex: 'value', key: 'value', ellipsis: true },
    { title: 'MÔ TẢ', dataIndex: 'description', key: 'description' },
    { 
        title: 'TRẠNG THÁI', 
        dataIndex: 'status', 
        key: 'status', 
        width: 120, 
        render: (s) => { 
            const map = { 0: ['default','TẠM DỪNG'], 1: ['green','KÍCH HOẠT'] }; 
            const [c,l] = map[s] || ['default', s]; 
            return <Tag color={c}>{l}</Tag>; 
        } 
    },
    { title: 'CẬP NHẬT GẦN NHẤT', dataIndex: 'updated_at', key: 'updated_at', width: 160, render: (t) => t ? dayjs(t).format('DD/MM/YYYY HH:mm') : '-' },
  ], []);

  const formFields = useMemo(() => [
    { name: 'key', label: 'Key cấu hình', type: 'input', rules: [{ required: true, message: 'Vui lòng nhập key!' }] },
    { name: 'value', label: 'Giá trị (Value)', type: 'textarea', propsInput: { rows: 4 }, rules: [{ required: true, message: 'Vui lòng nhập giá trị!' }] },
    { name: 'description', label: 'Mô tả', type: 'textarea', propsInput: { rows: 2 } },
    { name: 'status', label: 'Trạng thái', type: 'select', options: STATUS_OPTIONS, defaultValue: 1 },
  ], []);

  const filterFields = useMemo(() => [
    {
      label: 'Trạng thái',
      value: 'status',
      options: [
        { label: 'Tất cả', value: '' },
        ...STATUS_OPTIONS,
      ],
    },
  ], []);

  return (
    <CrudPage
      title="CẤU HÌNH SỨC KHỎE TINH THẦN"
      subTitle="Quản lý cấu hình chung cho ứng dụng Sức Khỏe Tinh Thần"
      itemsName="Cấu hình"
      queryKey="mentalHealthConfigList"
      service={mentalHealthConfigService}
      columns={columns}
      formFields={formFields}
      filterFields={filterFields}
      searchPlaceholder="Tìm kiếm theo key..."
      addButtonLabel="Thêm cấu hình"
      formConfig={{ width: 600 }}
    />
  );
};

export default QuanLyCauHinhSucKhoeTinhThan;
